'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002416 from "./presto.-Register-Page-View$$anon$16.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$15() {
  this.btE = null;
  this.btw = null;
  this.btx = false;
  this.btF = null;
  this.btG = false;
  this.btJ = null;
  this.btC = null;
  this.btD = false;
  this.bty = null;
  this.btz = false;
  this.btA = null;
  this.btB = false;
  this.btH = false;
  this.btI = false;
  this.btE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.btJ = "MorbidUserDetails";
}
export { $c_Lpresto_RegisterPageView$$anon$15 as $c_Lpresto_RegisterPageView$$anon$15 };
$p = $c_Lpresto_RegisterPageView$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$15;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$15() {
}
export { $h_Lpresto_RegisterPageView$$anon$15 as $h_Lpresto_RegisterPageView$$anon$15 };
$h_Lpresto_RegisterPageView$$anon$15.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.btE;
});
$p.L = (function() {
  if ((!this.btx)) {
    this.btw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.btx = true;
  }
  return this.btw;
});
$p.O = (function() {
  if ((!this.btG)) {
    this.btF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.btG = true;
  }
  return this.btF;
});
$p.E = (function() {
  return this.btJ;
});
$p.t = (function() {
  if ((!this.btD)) {
    this.btC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.btD = true;
  }
  return this.btC;
});
$p.M = (function() {
  if ((!this.btz)) {
    this.bty = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.btz = true;
  }
  return this.bty;
});
$p.Q = (function() {
  if ((!this.btB)) {
    this.btA = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002416.$c_Lpresto_RegisterPageView$$anon$16();
    this.btB = true;
  }
  return this.btA;
});
$p.w = (function() {
  if ((!this.btI)) {
    this.btH = false;
    this.btI = true;
  }
  return this.btH;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee113) => ((p) => \u03b4scrutinee113.GE(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_RegisterPageView$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$15, "presto.RegisterPageView$$anon$15", ({
  PW: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$15 as $d_Lpresto_RegisterPageView$$anon$15 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$15.js.map
